import { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { USER_ROLES, VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Button from '../../components/Button'
import Spinner from '../../components/Spinner'
import { USER_PATH, getUserById, updateUser } from '../../api/userApi'
import RolePicker from '../../components/user/RolePicker'
import { translateRole } from '../../utils/translator'

const UserEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const [entity, setEntity] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${USER_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${USER_PATH}`, false)

    useEffect(() => {
        getUserById(id).then(res => setEntity(res.data))
    }, [id])


    const onClickSubmit = () => {
        updateUser(id, entity)
            .then(res => {
                closeTab()
                toast.success('Kullanıcı güncellendi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Kullanıcı Düzenle</label>
                <Input
                    label='Kullanıcı Adı'
                    name='username'
                    placeholder='Kullanıcı adı girin...'
                    error={errors?.username}
                    value={entity.username}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Ad Soyad'
                    name='fullName'
                    placeholder='Ad Soyad girin...'
                    error={errors?.fullName}
                    value={entity.fullName}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='İşe Giriş Tarihi'
                    name='hireDate'
                    type='date'
                    error={errors?.hireDate}
                    value={entity.hireDate}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='İşten Çıkış Tarihi'
                    name='exitDate'
                    type='date'
                    error={errors?.exitDate}
                    value={entity.exitDate}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <RolePicker
                    label="Kullanıcı Rolü"
                    value={entity.role}
                    onChange={(role) => setEntity(prevState => ({ ...prevState, role }))}
                    text={translateRole(entity.role) || 'Kullanıcı rolü seçin'}
                    items={USER_ROLES}
                    error={errors?.role}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default UserEditPage